import { render, staticRenderFns } from "./ThreadsGrid.vue?vue&type=template&id=5304d581"
import script from "./ThreadsGrid.vue?vue&type=script&lang=js"
export * from "./ThreadsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports